import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-justificativa-info-dialog',
  templateUrl: './justificativa-info-dialog.component.html',
  styleUrls: ['./justificativa-info-dialog.component.scss']
})
export class JustificativaInfoDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<JustificativaInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { justificativa: string }
  ) {}

  get justificativaFormatada(): string {
    return this.data.justificativa.replace(/\\n/g, '\n');
  }

  fechar() {
    this.dialogRef.close();
  }
}